import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";

import { deleteUser, enableModal, updateModal } from "../../store/mainReducer";
import { logoutUser } from "../../api/user";
import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";

export const AccountModal = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.main.userData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleLogOut = () => {
    setLoading(true);
    //todo add logic
    logoutUser().then((response) => {
      window.localStorage.removeItem("token");
      dispatch(deleteUser());
      setLoading(false);
    });
  };

  const handleLogin = () => {
    dispatch(enableModal(true));
    dispatch(updateModal("loginView"));
  };

  const seeAccount = () => {
    dispatch(enableModal(false));
    navigate("/organization");
  };

  return (
    <div className="container-column" id="account-modal">
      {userData?.user ? (
        <>
          <div className="container-column" id="welcome">
            <h2>Hi {userData?.user.userName}</h2>
            <p style={{ marginTop: "20px" }}>Ready for the next event?</p>
          </div>
          <div className="container-column" id="buttons">
            <MainButton
              text="See my account"
              onClickAction={seeAccount}
              color={COLORS.lightNeon}
              textColor={COLORS.black}
            />
            {loading ? (
              <CircularProgress
                color="primary"
                style={{ alignSelf: "center" }}
              />
            ) : (
              <MainButton
                text="Log out"
                onClickAction={handleLogOut}
                color={COLORS.black}
                textColor={COLORS.white}
              />
            )}
          </div>
        </>
      ) : (
        <>
          <h2 style={{ margin: "0px 50px 50px" }}>Hi there</h2>
          <MainButton
            text="Login"
            onClickAction={handleLogin}
            color={COLORS.black}
            textColor={COLORS.white}
          />
        </>
      )}
    </div>
  );
};
